const $ = jQuery;

class Hotspot {
	/**
	 *
	 * @param {{element: DOM, container: HotspotContainer}}
	 */
	#label;
	#description;
	#tooltip;

	constructor({ element, container }) {
		this.hotspot = $(element);
		this.container = container;
		this.#label = this.hotspot.attr("data-hotspot-label");
		this.#description = this.hotspot.attr("data-hotspot-description");
		this.#tooltip = "";
		this.x = parseFloat(this.hotspot.attr("data-hotspot-x"));
		this.y = parseFloat(this.hotspot.attr("data-hotspot-y"));
		this.init();
	}

	init() {
		this.hotspot.appendTo(this.container.container);

		this.hotspot.css("position", `absolute`);
		this.hotspot.css("left", `${this.x}%`);
		this.hotspot.css("top", `${this.y}%`);

		this.generateTooltip();

		/**
		 * Handle the hotspot when it gets focus
		 */
		this.hotspot.on("mouseover", () => {
			this.showTooltip();
		});

		/**
		 * Handle the hotspot when it loses focus
		 */
		this.hotspot.on("mouseleave", (e) => {
			// Checks if the next target is a child of this hotspot
			const checkIfFocusWithin = (event) => {
				const nextTarget = this.hotspot.find(event.relatedTarget);
				if (nextTarget.length > 0) {
					$(nextTarget).on("blur", checkIfFocusWithin);
				} else {
					this.removeTooltip();
				}
			};

			checkIfFocusWithin(e);
		});

		this.hotspot.attr("data-hotspot-rendered", "");
	}

	/**
	 * Generates the tooltip box
	 */
	generateTooltip() {
		const tooltip = $("<div class='hotspot-tooltip'>");
		tooltip.attr("data-vertical-align", this.x > 50 ? "left" : "right");
		const label = $('<span class="hotspot-tooltip__label"></span>').html(
			this.#label
		);
		const description = $(
			'<div class="hotspot-tooltip__description"></div>'
		).html(this.#description);

		tooltip.append(label);
		tooltip.append(description);
		tooltip.hide();

		this.#tooltip = tooltip;
		this.hotspot.append(this.#tooltip);
	}

	/**
	 * Makes the tooltip fadein
	 */
	showTooltip() {
		this.#tooltip.fadeIn();
	}

	/**
	 * Makes the tooltip fadeout
	 */
	removeTooltip() {
		this.#tooltip.fadeOut();
	}
}

class HotspotContainer {
	constructor({ container, id }) {
		this.container = $(container);
		this.id = id;
		this.hotspots = [];
		this.init();
	}

	init() {
		this.container.css("position", "relative");
		this.container.css("width", "100%");

		/**
		 * Create a hotspot for each hotspot with the hotspot id
		 */
		$(`[data-hotspot-wrapper="${this.id}"]`).each((_i, hotspot) => {
			this.hotspots.push(
				new Hotspot({
					element: hotspot,
					container: this,
				})
			);
		});
	}
}

/**
 * Hotspots init
 */
const hotspots = {};
$("[data-hotspot-container]").each(function () {
	const id = $(this).attr("data-hotspot-container");
	hotspots[id] = new HotspotContainer({
		id,
		container: $(this),
	});
});
